import { combineReducers } from 'redux';

/*
|--------------------------------------------------------------------------
|  CURRENT VIEW REDUCER
|--------------------------------------------------------------------------
|
*/
const currentViewReducer = (state = null, action) => {
    switch(action.type) {
        case 'SET_CURRENT_VIEW' : 
            return action.payload;
        default :
            return state;
    }
}

export const setCurrentView = view => dispatch => {
    dispatch({ type: 'SET_CURRENT_VIEW', payload: view });
}

/*
|--------------------------------------------------------------------------
|  PAGES REDUCER
|--------------------------------------------------------------------------
|
*/
const pagesReducer = (state = {}, action) => {
    switch(action.type) {
        case 'ADD_TO_PAGES' : 
            return { ...state, [action.payload.key]: action.payload.page };
        default :
            return state;
    }
}

export const addToPages = page => dispatch => {
    dispatch({ type: 'ADD_TO_PAGES', payload: page });
}


/*
|--------------------------------------------------------------------------
|  SEARCH BLUR REDUCER
|--------------------------------------------------------------------------
|
*/
const searchBlurReducer = (state = false, action) => {
    switch(action.type) {
        case 'BLUR' : 
            return action.payload;
        default :
            return state;
    }
}

export const setSearchBlur = val => dispatch => {
    dispatch({ type: 'BLUR', payload: val });
}



/*
|--------------------------------------------------------------------------
|  ROUTE TRANSITION REDUCER
|--------------------------------------------------------------------------
|
*/
const routeTransitionReducer = (state = '', action) => {
    switch(action.type) {
        case 'TRANSITION_STATE_CHANGE' : 
            return action.payload;
        default :
            return state;
    }
}

export const setRouteTransitionState = value => dispatch => {
    dispatch({ type: 'TRANSITION_STATE_CHANGE', payload: value });
}




/*
|--------------------------------------------------------------------------
|  Main export
|--------------------------------------------------------------------------
|
*/
export const reducers = combineReducers({
    currentView:  currentViewReducer,
    pages: pagesReducer,
    searchBlur: searchBlurReducer,
    routeTransitionState: routeTransitionReducer,
});


// WEBPACK FOOTER //
// ./src/store.js